import React, { FC } from 'react'

import { Image, Dimmer, Header, Progress } from 'semantic-ui-react'

import VideoImagePlaceholder from '../../_images/video-upload-placeholder.jpg'

const ClipInProgressCard: FC<IProps> = ({ status, posterUrl }) => (
  <Dimmer.Dimmable
    style={{
      borderRadius: '0.28571429rem',
      overflow: 'hidden',
      paddingTop: '56.25%',
      position: 'relative',
      width: '100%',
    }}
  >
    <Image
      src={posterUrl || VideoImagePlaceholder}
      onError={({ currentTarget }: React.SyntheticEvent<HTMLImageElement>) => {
        currentTarget.onerror = null
        currentTarget.src = VideoImagePlaceholder
      }}
      rounded
      style={{
        border: '1px solid #e8e8e9',
        display: 'block',
        height: '100%',
        left: 0,
        objectFit: 'cover',
        position: 'absolute',
        top: 0,
        width: '100%',
      }}
    />
    <Dimmer active style={{ backgroundColor: 'rgba(0, 0, 0, 0.48)' }}>
      <Header inverted as="h4" style={{ textShadow: '0 1px 3px rgba(0, 0, 0, 0.9)' }}>
        Contributor video being processed
      </Header>
      <Header as="h5" inverted>
        <Progress size="small" color="violet" active percent={status - 100} />
      </Header>
    </Dimmer>
  </Dimmer.Dimmable>
)

interface IProps {
  status: number
  posterUrl?: string | null
}

export default ClipInProgressCard
